import { Box, Typography } from "@mui/material";
import { agentChatStyles as styles } from "./styles";

// The assistant writes a little markdown: **bold**, "- " / "1. " list lines and
// blank-line paragraphs. Rendered as React text (never HTML). A reply with any
// Hebrew in it reads right-to-left as a whole, in either app language — per-line
// dir="auto" would flip lines that start with "#f788" or a Latin name.

const BOLD = /\*\*(.+?)\*\*/g;

function inline(text) {
  const parts = [];
  let last = 0;
  for (const match of text.matchAll(BOLD)) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    parts.push(<strong key={match.index}>{match[1]}</strong>);
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

const LIST_ITEM = /^\s*(?:[-*•]|\d+[.)])\s+/;
const HEBREW = /[א-ת]/;

export default function AgentMessageText({ text }) {
  const blocks = text.trim().split(/\n{2,}/);
  const dir = HEBREW.test(text) ? "rtl" : "ltr";
  return blocks.map((block, i) => {
    const lines = block.split("\n").filter((line) => line.trim());
    if (lines.length && lines.every((line) => LIST_ITEM.test(line))) {
      return (
        <Box component="ul" key={i} dir={dir} sx={styles.textList}>
          {lines.map((line, j) => (
            <li key={j}>
              {inline(line.replace(LIST_ITEM, ""))}
            </li>
          ))}
        </Box>
      );
    }
    return (
      <Typography key={i} component="div" dir={dir} sx={styles.textBlock}>
        {lines.map((line, j) => (
          <Box key={j} sx={LIST_ITEM.test(line) ? styles.textListLine : undefined}>
            {inline(LIST_ITEM.test(line) ? `• ${line.replace(LIST_ITEM, "")}` : line.replace(/^#+\s+/, ""))}
          </Box>
        ))}
      </Typography>
    );
  });
}
